import { ID, IDPrefixes, Relationship } from '@griply/types';
import { createPrefixId } from '@griply/utils';

import { TaskRelationshipLink } from './create-task-with-sub-tasks';

// Builds the tag relationship links written alongside a task in the same batch,
// preserving each tag's existing references so the first snapshot already shows
// it tagged. Shared by every create-task path (full create + calendar timeslot).
export const buildTaskTagRelationshipLinks = (
  tagIds: ID[],
  relationships: Relationship[],
): TaskRelationshipLink[] =>
  tagIds.map((tagId) => {
    const id = createPrefixId(tagId, IDPrefixes.Tag);
    const existing = relationships.find(
      (relationship) => relationship.id === id,
    );
    return { id, existingReferences: existing?.references ?? null };
  });
